import { memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import UserAvatar from '../../userAvatar';
import Tooltip from '../../tooltip';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  user: {
    maxWidth: 'calc(100% - 22px)',
  },
}));

const User = ({ translations, user, hasTooltip }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <UserAvatar
        className={classes.user}
        user={user}
        variant="subtitle2"
        small
        caption
      />
      {hasTooltip && <Tooltip text={translations.roleChangeForbidden} />}
    </div>
  );
};

User.propTypes = {
  translations: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

export default memo(User);
